import { render, staticRenderFns } from "./investment-compare-tool.vue?vue&type=template&id=2cb37e80"
import script from "./investment-compare-tool.vue?vue&type=script&lang=js"
export * from "./investment-compare-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports